const initialState = {
    input: "",
    categoryInput: "",
    authorInput: "",
};

export default initialState;
